// src/config/roleConfig.js
export const ROLE_CONFIG = {
  doctor: {
    name: 'Doctor',
    sidebarItems: ['Patients', 'Enrollments', 'Call Sessions', 'Medical Centers'],
    permissions: {
      patients: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: false,  // Doctors cannot delete patients
        scope: 'medical_center' 
      },
      enrollments: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: false, 
        scope: 'medical_center' 
      },
      callSessions: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: false, 
        scope: 'medical_center' 
      },
      users: { 
        view: false, 
        create: false, 
        edit: false, 
        delete: false 
      },
      medicalCenters: { 
        view: true, 
        create: false, 
        edit: false, 
        delete: false 
      }
    }
  },
  
  manager: {
    name: 'Manager',
    sidebarItems: ['Patients', 'Enrollments', 'Call Sessions', 'Users', 'Medical Centers'],
    permissions: {
      patients: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: false,  // FIXED: Managers cannot delete patients (matches Rails policy)
        scope: 'medical_center' 
      },
      enrollments: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: false, 
        scope: 'medical_center' 
      },
      callSessions: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: false, 
        scope: 'medical_center' 
      },
      users: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: false, 
        scope: 'medical_center' 
      },
      medicalCenters: { 
        view: true, 
        create: false, 
        edit: false, 
        delete: false 
      }
    }
  },
  
  admin: {
    name: 'Admin',
    sidebarItems: ['Patients', 'Enrollments', 'Call Sessions', 'Users', 'Medical Centers'],
    permissions: {
      patients: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: true,  // Only admins can delete patients (matches Rails policy)
        scope: 'all' 
      },
      enrollments: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: true, 
        scope: 'all' 
      },
      callSessions: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: true, 
        scope: 'all' 
      },
      users: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: true, 
        scope: 'all' 
      },
      medicalCenters: { 
        view: true, 
        create: true, 
        edit: true, 
        delete: true, 
        scope: 'all' 
      }
    }
  }
};

export const ROUTES = {
  patients: '/patients',
  enrollments: '/enrollments',
  'call-sessions': '/call-sessions',
  users: '/users',
  'medical-centers': '/medical-centers',
  analytics: '/analytics'
};